// src/components/sections/FastExecution.jsx
import React from 'react';

const FastExecution = () => {
  return (
    <section className="fast-execution">
      <div className="container execution-content">
        <div className="execution-text slide-in-left">
          <p className="subtitle">LOWER LATENCY, HIGHER PROFITS</p>
          <h2>
            Sub-second Trade <span>Execution</span>
          </h2>
          <p>
            Kinetix is built directly on the Solana network, leveraging its speed to ensure your orders are processed within a single block confirmation cycle. Never miss a trade opportunity due to slow infrastructure.
          </p>

          <div className="execution-feature">
            <h3>Maximal Extractable Value (MEV) Protection</h3>
            <p>Our custom order routing prevents front-running and sandwich attacks, ensuring your execution price is the best possible.</p>
          </div>
        </div>

        <div className="execution-image scale-in">
          <div className="execution-visual">
            <i className="fas fa-bolt fa-3x" style={{ color: 'var(--accent-color)' }}></i>
            <div className="block-visual">
              <div className="block">
                TX
              </div>
            </div>
            <h4>Block Confirmation Time</h4>
            <div className="migration-sniper">
              <h4>Migration Sniper Technology</h4>
              <p>Execute limit orders with surgical precision, reducing slippage and ensuring fairness.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FastExecution;